import RecognitionFeed from 'components/recognitionFeed';
import { RebrandShell } from 'components/rebrand/RebrandShell';

import './styles.scss';

export default function Feed() {
  return (
    <RebrandShell
      title="Feed Reconheça BRB"
      subtitle="Acompanhe os reconhecimentos que estão acontecendo neste ciclo."
    >
      <RecognitionFeed />
    </RebrandShell>
  );
}
